export function addTrailingZeros(num) {
    if (num.includes(",")) {
        let _numParts = num.split(",");

        _numParts[1] = _numParts[1].padEnd(2, "0");
        return _numParts.join(",");
    } else {
        return num + ",00";
    }
}
